import { memo } from 'react'

import { SearchInputDebounced } from 'ui/components'
import { Select } from 'ui/components/Select'
import { FilterPanel } from 'ui/components/Table'
import { TableFilterRow } from 'ui/temp/TableFilterRow'

import { FilterProps } from './FilterProps'
import * as SC from './style'

const Filter = memo((props: FilterProps) => {
  const {
    webPageData,
    form: { isDirty, config, Field, Form },
    expanded,
    onToggle,
    onClean
  } = props

  const { statusOptions, creatorOptions, ownerOptions } = webPageData

  return (
    <Form config={config}>
      <FilterPanel
        isDirty={isDirty}
        onReset={onClean}
        expanded={expanded}
        onToggle={onToggle}
        customActions={<Field name="searchQuery" input={SearchInputDebounced} inputProps={{ 'data-qa': 'Search' }} />}
      >
        <SC.FormWrapper>
          <TableFilterRow>
            <SC.FieldBox>
              <Field
                name="status"
                label="Status"
                input={Select}
                inputProps={{
                  data: statusOptions ?? []
                }}
              />
            </SC.FieldBox>
            <SC.FieldBox>
              <Field
                name="createdById"
                label="Created By"
                input={Select}
                inputProps={{
                  data: creatorOptions ?? [],
                  searchable: true
                }}
              />
            </SC.FieldBox>
            <SC.FieldBox>
              <Field
                name="currentOwnerId"
                label="Current Owner"
                input={Select}
                inputProps={{
                  data: ownerOptions ?? [],
                  searchable: true
                }}
              />
            </SC.FieldBox>
          </TableFilterRow>
        </SC.FormWrapper>
      </FilterPanel>
    </Form>
  )
})

export { Filter }
